export default {"src":"/_next/static/media/file.f63bd35f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};